






import Vue from 'vue'
import { StockOutPlanMaterialServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
const sopmsp = new StockOutPlanMaterialServiceProxy()
const columns = [
  {
    title: 'page_plan_item_no',
    dataIndex: 'materialCode',
    key: 'materialCode'
  },
  {
    title: 'page_quality_report_material_name',
    dataIndex: 'materialName',
    key: 'materialName'
  },
  {
    title: 'page_job_make_delivery_inventory_quantity',
    dataIndex: 'totalNum',
    key: 'totalNum'
  },
  {
    title: 'page_material_delivery_plan_issue_quantity',
    key: 'requireNum',
    dataIndex: 'requireNum'
  },
  {
    title: 'page_material_delivery_plan_issued_quantity',
    dataIndex: 'deliveredNum',
    key: 'deliveredNum'
  },
  {
    title: 'page_job_make_delivery_quantity_be_issued',
    dataIndex: 'toBeDeliveredNum',
    key: 'toBeDeliveredNum'
  }
]

export default Vue.extend({
  props: {
    editData: {
      type: Object,
      default: () => ({})
    },
    bot: {
      type: Number,
      default: 0
    },
    source: {
      type: Number,
      default: 0
    }
  },
  watch: {
    editData: {
      handler() {
        this.dataSource = []
        if (this.editData && this.editData.id) {
          this.getList()
        }
      },
      deep: true,
      immediate: true
    },
    source: {
      handler() {
        this.changeScroll()
      },
      deep: true,
      immediate: true
    },
    bot: {
      handler() {
        this.dataSource = []
        if (this.editData && this.editData.id) {
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  data() {
    return {
      dataSource: [],
      scrollY: 0
    }
  },
  methods: {
    async getList() {
      const res = await sopmsp.listStockOutPlanMaterial(this.editData.id)
      this.dataSource = res
      this.changeScroll()
    },
    changeScroll() {
      const dev = document.getElementById('bottom-body')
      if (dev && (dev.clientHeight - 40) < this.dataSource.length * 32) {
        this.scrollY = dev.clientHeight - 40
      } else {
        this.scrollY = 0
      }
    }
  }
})
